import { render, staticRenderFns } from "./EditReservationsVentrata.vue?vue&type=template&id=fbcd4b60"
import script from "./EditReservationsVentrata.vue?vue&type=script&lang=js"
export * from "./EditReservationsVentrata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports